import React from "react";
import BigAdd from "./BigAdd";
import Karnataka2 from './karnataka2'
import BollywoodNews2 from "./BollywoodNews2";
import InternationalDetails2 from "./InternationalDetails2";

// import './style1.css';

const KarnatakaDetails = () => {
  return (
    <div>
      <div className="ak-post-wrapper" style={{ transform: "none" }}>
        <div className="ak-content-wrap ak-post-wrap ak-layout-style-1 clearfix ak-post-style-7 clearfix" style={{ transform: "none" }}>
          <div className="ak-container" style={{ transform: "none" }}>
            <div className="ak-content" style={{ transform: "none" }}>
              <div className="" style={{ transform: "none" }}>
                <div className="mt-2">
                  <BigAdd />
                </div>
                <div className="row d-flex flex-wrap" style={{ transform: "none" }}>
                  <div className="ak_column_1 col-md-9 order-1 order-md-2">
                    <div className="">
                      <h1 className="head" style={{ color: "crimson" }}>
                        कर्नाटक (आज की कर्नाटक की ताज़ा खबरें हिंदी में)
                      </h1>
                    </div>
                    <div className="ak-article-inner">
                      < Karnataka2 />
                    </div>
                  </div>

                  {/* Sidebar - Appears below content on mobile, but stays right on desktop */}
                  <div className="ak_column_ col-md-3 order-2 order-md-1 sidebar-column sidebar-column-primary-right sticky-sidebar"
                    style={{ position: "relative", overflow: "visible", boxSizing: "border-box", minHeight: 1 }}>
                    <div className="theiaStickySidebar" style={{ paddingTop: 0, paddingBottom: 1, position: "sticky", transform: "none", top: 0, left: "914.5px" }}>
                      <div className="post-sidebar">
                        <BollywoodNews2 />
                        <InternationalDetails2 />
                        {/* <Madhyapradesh4 />
                        <Madhyapradesh5 />
                        <Madhyapradesh1 />
                        <div className="mt-2">
                          <Madhyapradesh3 />
                        </div> */}
                      </div>
                    </div>
                  </div>

                </div> {/* End row */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  );
}

export default KarnatakaDetails;
